import React from "react";
import ReactDOM from "react-dom";

import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Settings } from "luxon";
import App from "./App";

// Set the default locale to French globally
Settings.defaultLocale = "fr";
Settings.defaultZone = "Pacific/Tahiti";

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
